import { Component, OnInit } from '@angular/core';
import { AccountService } from './../_services/account.service';
import { IRegisterModel } from './../_models/RegisterModel';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastService } from 'on-common/_services/toast.service';

@Component({
    selector: 'on-register-page',
    templateUrl: './register-page.component.html',
    styleUrls: ['./register-page.component.scss'],
})
export class RegisterPageComponent implements OnInit {
    isLoading = false;
    token: string;
    email: string;

    constructor(
        private accountService: AccountService,
        private toastService: ToastService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
    ) {}

    ngOnInit() {
        this.token = this.activatedRoute.snapshot.queryParams['token'];
        this.email = this.activatedRoute.snapshot.queryParams['email'];
    }

    Register(registermodel?: IRegisterModel) {
        this.isLoading = true;
        this.accountService
            .Register(
                registermodel.UserName,
                registermodel.Password,
                registermodel.Country,
                registermodel.Currency,
                registermodel.LanguageCode,
                this.token,
            )
            .subscribe(
                (response) => {
                    if (response.IsSuccess) {
                        this.toastService.success(
                            'Bienvenue sur ONexpense !',
                            'Enregistrement réussi',
                        );
                        this.accountService
                            .LogIn(
                                registermodel.UserName,
                                registermodel.Password,
                            )
                            .subscribe((res) => {
                                if (
                                    this.activatedRoute.snapshot.queryParams[
                                        'returnUrl'
                                    ]
                                ) {
                                    this.router.navigateByUrl(
                                        this.activatedRoute.snapshot
                                            .queryParams['returnUrl'],
                                    );
                                } else {
                                    this.router.navigate(['/expenses']);
                                }
                            });
                    } else {
                        this.toastService.error(
                            "Une erreur est intervenue lors de l'enregistrement",
                        );
                        this.isLoading = false;
                    }
                },
                (error) => {
                    this.toastService.error(
                        "Une erreur est intervenue lors de l'enregistrement",
                    );
                    this.isLoading = false;
                },
            );
    }
}
